import { useMemo, useState } from 'react'
import api from '../Api'
import { makeQueryParams } from './shared'

const SitesParams = {
  city: 'City=',
  country: 'Country=',
  licenseId: 'LicenseId=',
  siteId: 'SiteId=',
  nsCustomerId: 'NSCustomerId=',
  organizationId: 'OrganizationId=',
  name: 'Name=',
  postalCode: 'PostalCode=',
  region: 'Region=',
  userId: 'UserId=',
  userRole: 'UserRole=',
}

export const getSites = props => {
  const { licenseId, siteId } = props
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const getSitesCall = async () => {
    setLoading(true)
    setError(false)

    const params = makeQueryParams(props, SitesParams)
    if (!params) {
      setLoading(false)
      return
    }

    try {
      const res = await api.get(`/sites?${params}`)
      setData(res.data)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useMemo(() => {
    getSitesCall()
  }, [licenseId, siteId])

  return { data, loading, error }
}

export const getSitesUsers = siteId => {
  const [data, setData] = useState(null)
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)

  const getSitesUsersCall = async () => {
    setLoading(true)
    setError(null)

    if (!siteId) {
      setLoading(false)
      return
    }

    try {
      const res = await api.get(`/sites/${siteId}/siteusers`)
      setData(res.data)
    } catch (error) {
      setError(error)
    } finally {
      setLoading(false)
    }
  }

  useMemo(() => {
    getSitesUsersCall()
  }, [siteId])

  return { data, loading, error }
}



// WEBPACK FOOTER //
// ./src/lib/apiHooks/SitesApi.js